/**
 *
 * @export
 * @interface UserServiceApiAddMagicLinkPasswordRequestDto
 */
export interface UserServiceApiAddMagicLinkPasswordRequestDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceApiAddMagicLinkPasswordRequestDto
   */
  targetId: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiAddMagicLinkPasswordRequestDto
   */
  type: UserServiceApiAddMagicLinkPasswordRequestDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiAddMagicLinkPasswordRequestDto
   */
  password: string;
}

export const UserServiceApiAddMagicLinkPasswordRequestDtoTypeEnum = {
  Portal: 'portal',
} as const;

export type UserServiceApiAddMagicLinkPasswordRequestDtoTypeEnum =
  (typeof UserServiceApiAddMagicLinkPasswordRequestDtoTypeEnum)[keyof typeof UserServiceApiAddMagicLinkPasswordRequestDtoTypeEnum];

/**
 *
 * @export
 * @interface UserServiceApiAuthMagicLinkRequestDto
 */
export interface UserServiceApiAuthMagicLinkRequestDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceApiAuthMagicLinkRequestDto
   */
  password: string;
}
/**
 *
 * @export
 * @interface UserServiceApiCreateMagicLinksByUnauthorizedUserRequestDto
 */
export interface UserServiceApiCreateMagicLinksByUnauthorizedUserRequestDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceApiCreateMagicLinksByUnauthorizedUserRequestDto
   */
  type: UserServiceApiCreateMagicLinksByUnauthorizedUserRequestDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiCreateMagicLinksByUnauthorizedUserRequestDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiCreateMagicLinksByUnauthorizedUserRequestDto
   */
  workspaceId: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiCreateMagicLinksByUnauthorizedUserRequestDto
   */
  url: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiCreateMagicLinksByUnauthorizedUserRequestDto
   */
  linkName: string;
  /**
   *
   * @type {UserServiceApiCreateMagicLinksByUnauthorizedUserRequestPermissionsDto}
   * @memberof UserServiceApiCreateMagicLinksByUnauthorizedUserRequestDto
   */
  permissions?: UserServiceApiCreateMagicLinksByUnauthorizedUserRequestPermissionsDto;
}

export const UserServiceApiCreateMagicLinksByUnauthorizedUserRequestDtoTypeEnum = {
  Portal: 'portal',
} as const;

export type UserServiceApiCreateMagicLinksByUnauthorizedUserRequestDtoTypeEnum =
  (typeof UserServiceApiCreateMagicLinksByUnauthorizedUserRequestDtoTypeEnum)[keyof typeof UserServiceApiCreateMagicLinksByUnauthorizedUserRequestDtoTypeEnum];

/**
 *
 * @export
 * @interface UserServiceApiCreateMagicLinksByUnauthorizedUserRequestPermissionsDto
 */
export interface UserServiceApiCreateMagicLinksByUnauthorizedUserRequestPermissionsDto {
  /**
   *
   * @type {boolean}
   * @memberof UserServiceApiCreateMagicLinksByUnauthorizedUserRequestPermissionsDto
   */
  owner?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UserServiceApiCreateMagicLinksByUnauthorizedUserRequestPermissionsDto
   */
  manager?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UserServiceApiCreateMagicLinksByUnauthorizedUserRequestPermissionsDto
   */
  member?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UserServiceApiCreateMagicLinksByUnauthorizedUserRequestPermissionsDto
   */
  guest?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UserServiceApiCreateMagicLinksByUnauthorizedUserRequestPermissionsDto
   */
  anyone?: boolean;
}
/**
 *
 * @export
 * @interface UserServiceApiCreateMagicLinksRequestDto
 */
export interface UserServiceApiCreateMagicLinksRequestDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceApiCreateMagicLinksRequestDto
   */
  type: UserServiceApiCreateMagicLinksRequestDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiCreateMagicLinksRequestDto
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiCreateMagicLinksRequestDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiCreateMagicLinksRequestDto
   */
  workspaceId?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiCreateMagicLinksRequestDto
   */
  url: string;
  /**
   *
   * @type {number}
   * @memberof UserServiceApiCreateMagicLinksRequestDto
   */
  expiresAt?: number;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiCreateMagicLinksRequestDto
   */
  orgRole?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiCreateMagicLinksRequestDto
   */
  workspaceRole?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiCreateMagicLinksRequestDto
   */
  usePassword?: string;
}

export const UserServiceApiCreateMagicLinksRequestDtoTypeEnum = {
  Portal: 'portal',
} as const;

export type UserServiceApiCreateMagicLinksRequestDtoTypeEnum =
  (typeof UserServiceApiCreateMagicLinksRequestDtoTypeEnum)[keyof typeof UserServiceApiCreateMagicLinksRequestDtoTypeEnum];

/**
 *
 * @export
 * @interface UserServiceApiDeleteMagicLinkPasswordRequestDto
 */
export interface UserServiceApiDeleteMagicLinkPasswordRequestDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceApiDeleteMagicLinkPasswordRequestDto
   */
  targetId: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiDeleteMagicLinkPasswordRequestDto
   */
  type: UserServiceApiDeleteMagicLinkPasswordRequestDtoTypeEnum;
}

export const UserServiceApiDeleteMagicLinkPasswordRequestDtoTypeEnum = {
  Portal: 'portal',
} as const;

export type UserServiceApiDeleteMagicLinkPasswordRequestDtoTypeEnum =
  (typeof UserServiceApiDeleteMagicLinkPasswordRequestDtoTypeEnum)[keyof typeof UserServiceApiDeleteMagicLinkPasswordRequestDtoTypeEnum];

/**
 *
 * @export
 * @interface UserServiceApiGetMagicLinkPassword200ResponseDto
 */
export interface UserServiceApiGetMagicLinkPassword200ResponseDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceApiGetMagicLinkPassword200ResponseDto
   */
  password: string;
  /**
   *
   * @type {boolean}
   * @memberof UserServiceApiGetMagicLinkPassword200ResponseDto
   */
  removed: boolean;
}
/**
 *
 * @export
 * @interface UserServiceApiGetUserShortInfos200ResponseInnerDto
 */
export interface UserServiceApiGetUserShortInfos200ResponseInnerDto {
  /**
   *
   * @type {number}
   * @memberof UserServiceApiGetUserShortInfos200ResponseInnerDto
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiGetUserShortInfos200ResponseInnerDto
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiGetUserShortInfos200ResponseInnerDto
   */
  displayName?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiGetUserShortInfos200ResponseInnerDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiGetUserShortInfos200ResponseInnerDto
   */
  firstname?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiGetUserShortInfos200ResponseInnerDto
   */
  lastname?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiGetUserShortInfos200ResponseInnerDto
   */
  avatarFileUuid?: string;
}
/**
 *
 * @export
 * @interface UserServiceApiRestoreMagicLink200ResponseDto
 */
export interface UserServiceApiRestoreMagicLink200ResponseDto {
  /**
   *
   * @type {boolean}
   * @memberof UserServiceApiRestoreMagicLink200ResponseDto
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiRestoreMagicLink200ResponseDto
   */
  email?: string;
}
/**
 *
 * @export
 * @interface UserServiceApiRestoreMagicLinkRequestDto
 */
export interface UserServiceApiRestoreMagicLinkRequestDto {
  /**
   *
   * @type {number}
   * @memberof UserServiceApiRestoreMagicLinkRequestDto
   */
  userId: number;
}
/**
 *
 * @export
 * @interface UserServiceApiValidateMagicLink200ResponseDto
 */
export interface UserServiceApiValidateMagicLink200ResponseDto {
  /**
   *
   * @type {boolean}
   * @memberof UserServiceApiValidateMagicLink200ResponseDto
   */
  success: boolean;
  /**
   *
   * @type {number}
   * @memberof UserServiceApiValidateMagicLink200ResponseDto
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof UserServiceApiValidateMagicLink200ResponseDto
   */
  url: string;
  /**
   *
   * @type {boolean}
   * @memberof UserServiceApiValidateMagicLink200ResponseDto
   */
  usePassword?: boolean;
}
/**
 *
 * @export
 * @interface UserServiceAvatarDto
 */
export interface UserServiceAvatarDto {
  userId: number;
  /**
   *
   * @type {string}
   * @memberof UserServiceAvatarDto
   */
  storedFileUUID: string;
  /**
   *
   * @type {number}
   * @memberof UserServiceAvatarDto
   */
  createdAt: number;
  /**
   *
   * @type {number}
   * @memberof UserServiceAvatarDto
   */
  updatedAt: number;
}
/**
 *
 * @export
 * @interface UserServiceChangeEmailObjectDto
 */
export interface UserServiceChangeEmailObjectDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceChangeEmailObjectDto
   */
  newEmail: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceChangeEmailObjectDto
   */
  orgId?: string;
}
/**
 *
 * @export
 * @interface UserServiceChangePasswordObjectDto
 */
export interface UserServiceChangePasswordObjectDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceChangePasswordObjectDto
   */
  oldPassword?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceChangePasswordObjectDto
   */
  newPassword: string;
  /**
   * This session won\'t be destroyed after the password change, usually it is the session the password is changing in
   * @type {string}
   * @memberof UserServiceChangePasswordObjectDto
   */
  saveSessionId?: string;
}
/**
 *
 * @export
 * @interface UserServiceComparePasswordObjectDto
 */
export interface UserServiceComparePasswordObjectDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceComparePasswordObjectDto
   */
  password: string;
  /**
   *
   * @type {boolean}
   * @memberof UserServiceComparePasswordObjectDto
   */
  prehash?: boolean;
}
/**
 *
 * @export
 * @interface UserServiceConfirmEmailParamsDto
 */
export interface UserServiceConfirmEmailParamsDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceConfirmEmailParamsDto
   */
  saveSessionId?: string;
}
/**
 *
 * @export
 * @interface UserServiceCreateSessionExchangeDataDto
 */
export interface UserServiceCreateSessionExchangeDataDto {
  /**
   * Session identified
   * @type {string}
   * @memberof UserServiceCreateSessionExchangeDataDto
   */
  id: string;
}
/**
 *
 * @export
 * @interface UserServiceCreateSessionObjectDto
 */
export interface UserServiceCreateSessionObjectDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceCreateSessionObjectDto
   */
  ip: string;
}
/**
 *
 * @export
 * @interface UserServiceEncryptionKeyCreateObjectDto
 */
export interface UserServiceEncryptionKeyCreateObjectDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceEncryptionKeyCreateObjectDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceEncryptionKeyCreateObjectDto
   */
  publicKey: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceEncryptionKeyCreateObjectDto
   */
  privateKey: string;
}
/**
 *
 * @export
 * @interface UserServiceEncryptionKeyDto
 */
export interface UserServiceEncryptionKeyDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceEncryptionKeyDto
   */
  uuid: string;
  /**
   *
   * @type {number}
   * @memberof UserServiceEncryptionKeyDto
   */
  dateAdded: number;
  /**
   *
   * @type {string}
   * @memberof UserServiceEncryptionKeyDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceEncryptionKeyDto
   */
  publicKey: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceEncryptionKeyDto
   */
  privateKey: string;
}
/**
 *
 * @export
 * @interface UserServiceErrorResponseDto
 */
export interface UserServiceErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceErrorResponseDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface UserServiceInternalErrorResponseDto
 */
export interface UserServiceInternalErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceInternalErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceInternalErrorResponseDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface UserServiceMagicLinkDto
 */
export interface UserServiceMagicLinkDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceMagicLinkDto
   */
  type: UserServiceMagicLinkDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof UserServiceMagicLinkDto
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof UserServiceMagicLinkDto
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof UserServiceMagicLinkDto
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceMagicLinkDto
   */
  workspaceId: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceMagicLinkDto
   */
  url: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceMagicLinkDto
   */
  magicLink: string;
  /**
   *
   * @type {boolean}
   * @memberof UserServiceMagicLinkDto
   */
  usePassword: boolean;
  /**
   *
   * @type {number}
   * @memberof UserServiceMagicLinkDto
   */
  createdAt: number;
  /**
   *
   * @type {number}
   * @memberof UserServiceMagicLinkDto
   */
  updatedAt: number;
  /**
   *
   * @type {number}
   * @memberof UserServiceMagicLinkDto
   */
  deletedAt?: number;
  /**
   *
   * @type {number}
   * @memberof UserServiceMagicLinkDto
   */
  expiresAt?: number;
}

export const UserServiceMagicLinkDtoTypeEnum = {
  Portal: 'portal',
} as const;

export type UserServiceMagicLinkDtoTypeEnum =
  (typeof UserServiceMagicLinkDtoTypeEnum)[keyof typeof UserServiceMagicLinkDtoTypeEnum];

/**
 *
 * @export
 * @interface UserServiceNewUserObjectDto
 */
export interface UserServiceNewUserObjectDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceNewUserObjectDto
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceNewUserObjectDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceNewUserObjectDto
   */
  firstname?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceNewUserObjectDto
   */
  lastname?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceNewUserObjectDto
   */
  password?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceNewUserObjectDto
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceNewUserObjectDto
   */
  service?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceNewUserObjectDto
   */
  remoteApplication?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof UserServiceNewUserObjectDto
   */
  languages?: Array<string>;
  /**
   * arbitrary information to be sent in user:registered event
   * @type {object}
   * @memberof UserServiceNewUserObjectDto
   */
  meta?: object;
}
/**
 *
 * @export
 * @interface UserServiceNotFoundErrorResponseDto
 */
export interface UserServiceNotFoundErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceNotFoundErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceNotFoundErrorResponseDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface UserServicePasswordObjectDto
 */
export interface UserServicePasswordObjectDto {
  /**
   *
   * @type {string}
   * @memberof UserServicePasswordObjectDto
   */
  password: string;
}
/**
 *
 * @export
 * @interface UserServicePremiumExtendObjectDto
 */
export interface UserServicePremiumExtendObjectDto {
  /**
   *
   * @type {number}
   * @memberof UserServicePremiumExtendObjectDto
   */
  days: number;
  /**
   *
   * @type {number}
   * @memberof UserServicePremiumExtendObjectDto
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof UserServicePremiumExtendObjectDto
   */
  type: string;
}
/**
 *
 * @export
 * @interface UserServiceRestorePasswordSessionDto
 */
export interface UserServiceRestorePasswordSessionDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceRestorePasswordSessionDto
   */
  key: string;
}
/**
 *
 * @export
 * @interface UserServiceSessionDto
 */
export interface UserServiceSessionDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceSessionDto
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof UserServiceSessionDto
   */
  createDate: number;
  /**
   *
   * @type {string}
   * @memberof UserServiceSessionDto
   */
  ip: string;
  /**
   *
   * @type {number}
   * @memberof UserServiceSessionDto
   */
  userId?: number;
  /**
   *
   * @type {UserServiceSessionUserDto}
   * @memberof UserServiceSessionDto
   */
  user?: UserServiceSessionUserDto;
  /**
   *
   * @type {string}
   * @memberof UserServiceSessionDto
   */
  token?: string;
  /**
   *
   * @type {object}
   * @memberof UserServiceSessionDto
   */
  data?: object;
  /**
   *
   * @type {number}
   * @memberof UserServiceSessionDto
   */
  ttl?: number;
}
/**
 *
 * @export
 * @interface UserServiceSessionExchangeDto
 */
export interface UserServiceSessionExchangeDto {
  /**
   * Session identified
   * @type {string}
   * @memberof UserServiceSessionExchangeDto
   */
  id: string;
  /**
   * Timestamp when exchange was created
   * @type {number}
   * @memberof UserServiceSessionExchangeDto
   */
  time?: number;
}
/**
 *
 * @export
 * @interface UserServiceSessionExchangeTokenDto
 */
export interface UserServiceSessionExchangeTokenDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceSessionExchangeTokenDto
   */
  token?: string;
}
/**
 *
 * @export
 * @interface UserServiceSessionShortInfoDto
 */
export interface UserServiceSessionShortInfoDto {
  /**
   *
   * @type {number}
   * @memberof UserServiceSessionShortInfoDto
   */
  createdAt?: number;
}
/**
 *
 * @export
 * @interface UserServiceSessionUserDto
 */
export interface UserServiceSessionUserDto {
  /**
   *
   * @type {number}
   * @memberof UserServiceSessionUserDto
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof UserServiceSessionUserDto
   */
  login?: string;
}
/**
 *
 * @export
 * @interface UserServiceTimezoneDto
 */
export interface UserServiceTimezoneDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceTimezoneDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceTimezoneDto
   */
  offset: string;
}
/**
 *
 * @export
 * @interface UserServiceUpdateAvatarObjectDto
 */
export interface UserServiceUpdateAvatarObjectDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceUpdateAvatarObjectDto
   */
  tempFileName: string;
}
/**
 *
 * @export
 * @interface UserServiceUpdatePaymentSystemObjectDto
 */
export interface UserServiceUpdatePaymentSystemObjectDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceUpdatePaymentSystemObjectDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceUpdatePaymentSystemObjectDto
   */
  details?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceUpdatePaymentSystemObjectDto
   */
  uniqueSign?: string;
}
/**
 *
 * @export
 * @interface UserServiceUpdateSessionObjectDto
 */
export interface UserServiceUpdateSessionObjectDto {
  /**
   *
   * @type {number}
   * @memberof UserServiceUpdateSessionObjectDto
   */
  userId?: number;
  /**
   *
   * @type {object}
   * @memberof UserServiceUpdateSessionObjectDto
   */
  data?: object;
}
/**
 *
 * @export
 * @interface UserServiceUpdateUserObjectDto
 */
export interface UserServiceUpdateUserObjectDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceUpdateUserObjectDto
   */
  service?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceUpdateUserObjectDto
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceUpdateUserObjectDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceUpdateUserObjectDto
   */
  defaultEncryptionKeyId?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceUpdateUserObjectDto
   */
  firstname?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceUpdateUserObjectDto
   */
  lastname?: string;
  /**
   *
   * @type {boolean}
   * @memberof UserServiceUpdateUserObjectDto
   */
  subscribeNewsletter?: boolean;
}
/**
 *
 * @export
 * @interface UserServiceUserDto
 */
export interface UserServiceUserDto {
  /**
   *
   * @type {number}
   * @memberof UserServiceUserDto
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof UserServiceUserDto
   */
  displayName?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceUserDto
   */
  email: string;
  /**
   *
   * @type {number}
   * @memberof UserServiceUserDto
   */
  registerDate: number;
  /**
   *
   * @type {boolean}
   * @memberof UserServiceUserDto
   */
  subscribeNewsletter?: boolean;
  /**
   *
   * @type {string}
   * @memberof UserServiceUserDto
   */
  service?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceUserDto
   */
  remoteApplication?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof UserServiceUserDto
   */
  languages?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof UserServiceUserDto
   */
  emailConfirmed?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UserServiceUserDto
   */
  emailDeliverySuspended?: boolean;
}
/**
 *
 * @export
 * @interface UserServiceUserPaymentSystemDto
 */
export interface UserServiceUserPaymentSystemDto {
  /**
   *
   * @type {number}
   * @memberof UserServiceUserPaymentSystemDto
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof UserServiceUserPaymentSystemDto
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof UserServiceUserPaymentSystemDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceUserPaymentSystemDto
   */
  details?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceUserPaymentSystemDto
   */
  uniqueSign?: string;
}
/**
 *
 * @export
 * @interface UserServiceUserPremiumDto
 */
export interface UserServiceUserPremiumDto {
  /**
   *
   * @type {number}
   * @memberof UserServiceUserPremiumDto
   */
  userId?: number;
  /**
   *
   * @type {string}
   * @memberof UserServiceUserPremiumDto
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceUserPremiumDto
   */
  status: UserServiceUserPremiumDtoStatusEnum;
  /**
   *
   * @type {number}
   * @memberof UserServiceUserPremiumDto
   */
  startDate?: number;
  /**
   *
   * @type {number}
   * @memberof UserServiceUserPremiumDto
   */
  endDate?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof UserServiceUserPremiumDto
   */
  inheritedFromOrg?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof UserServiceUserPremiumDto
   */
  isBusiness?: boolean;
}

export const UserServiceUserPremiumDtoStatusEnum = {
  Unpayed: 'unpayed',
  Active: 'active',
  Expired: 'expired',
  Cancelled: 'cancelled',
} as const;

export type UserServiceUserPremiumDtoStatusEnum =
  (typeof UserServiceUserPremiumDtoStatusEnum)[keyof typeof UserServiceUserPremiumDtoStatusEnum];

/**
 *
 * @export
 * @interface UserServiceUserRestorePasswordObjectDto
 */
export interface UserServiceUserRestorePasswordObjectDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceUserRestorePasswordObjectDto
   */
  email: string;
  /**
   * service to send email from
   * @type {string}
   * @memberof UserServiceUserRestorePasswordObjectDto
   */
  service?: string;
}
/**
 *
 * @export
 * @interface UserServiceValidationErrorResponseDto
 */
export interface UserServiceValidationErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof UserServiceValidationErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceValidationErrorResponseDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceValidationErrorResponseDto
   */
  field?: string;
  /**
   *
   * @type {string}
   * @memberof UserServiceValidationErrorResponseDto
   */
  reason?: string;
}
